import React from 'react'
import {Dialog, DialogTitle, DialogContent, makeStyles, Typography, DialogActions, useMediaQuery, useTheme} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ActionButton from "../form/input/ActionButton";

const useStyles = makeStyles(theme => ({
    dialogWrapper: {
        borderRadius: 14,
        border: '1px solid rgba(176, 141, 87, 0.18)',
        boxShadow: '0 24px 64px rgba(44, 71, 103, 0.22)',
        overflow: 'hidden',
        [theme.breakpoints.down('xs')]: {
            borderRadius: 0,
            border: 0,
            margin: 0,
            maxHeight: '100%',
            height: '100%',
            width: '100%',
            maxWidth: '100%',
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            background: 'linear-gradient(90deg, #2c4767 0%, #b08d57 100%)',
            zIndex: 2,
        },
    },
    dialogTitle: {
        padding: theme.spacing(2.5, 3),
        paddingRight: theme.spacing(1.5),
        background: '#ffffff',
        borderBottom: '1px solid rgba(176, 141, 87, 0.18)',
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        fontWeight: 700,
        color: '#1a2733',
        fontSize: '1.15rem',
        letterSpacing: '-0.2px',
    },
    content: {
        padding: theme.spacing(3),
        background: '#fbfaf7',
        maxHeight: 'calc(100vh - 190px)',
        overflow: 'auto',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
            maxHeight: 'calc(100vh - 150px)',
        },
    },
    actions: {
        padding: theme.spacing(2, 3),
        background: '#ffffff',
        borderTop: '1px solid rgba(176, 141, 87, 0.18)',
        gap: theme.spacing(1),
    },
}))

const sizeMinWidths = {
    xs: 360,
    sm: 520,
    md: 720,
    lg: 960,
    xl: 1200,
};

export default function Popup(props) {

    const { title, children, openPopup, setOpenPopup, actions, additionalWork = null, maxW = 'md'} = props;
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    const minWidth = isMobile ? undefined : (sizeMinWidths[maxW] || sizeMinWidths.md);
    const paperStyle = isMobile ? undefined : {
        minWidth: `min(${minWidth}px, calc(100vw - 32px))`,
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: 'calc(100vh - 32px)',
    };

    const handleClose = () => {
        if (additionalWork) {
            additionalWork();
        }
        setOpenPopup(false);
    };

    return (
        <Dialog
            open={openPopup}
            onClose={handleClose}
            maxWidth={maxW}
            fullWidth
            fullScreen={isMobile}
            classes={{paper: classes.dialogWrapper}}
            PaperProps={{style: paperStyle}}
        >
            <DialogTitle disableTypography className={classes.dialogTitle}>
                <div className={classes.titleRow}>
                    <Typography variant="h6" component="div" className={classes.title}>
                        {title}
                    </Typography>
                    <ActionButton
                        color="secondary"
                        onClick={handleClose}>
                        <CloseIcon/>
                    </ActionButton>
                </div>
            </DialogTitle>
            <DialogContent dividers className={classes.content}>
                {children}
            </DialogContent>
            {actions ? (
                <DialogActions className={classes.actions}>
                    {actions}
                </DialogActions>
            ) : null}
        </Dialog>
    )
}